<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import { fly } from 'svelte/transition'

    // import axios from 'axios'
    import moment from 'moment'
    // import 'moment/locale/it'

    import Modal from '../../components/Modal/Modal.svelte'
    import ModalOverlay from '../../components/Modal/ModalOverlay.svelte'
    import SveltePerfectScrollbar from '../../components/SveltePerfectScrollbar/SveltePerfectScrollbar.svelte'
    import ListClients from '../Programs/ListClients.svelte'
    import ListField from '../Programs/ListField.svelte'
    import ListOperators from '../Programs/ListOperators.svelte'
    import ListWorks from '../Programs/ListWorks.svelte'
    import ListAreas from '../Programs/ListAreas.svelte'
    import SmartField from '../../components/SmartField/SmartField.svelte'
    import SmartSelect from '../../components/SmartField/SmartSelect.svelte'
    import CronEditor from './CronEditor.svelte'
    import CronRenderer from './CronRenderer.svelte'
    import userStore from '../../stores/user'
    

    export let data
    export let create = false
    export let client = null
    
    let ctrlsDisabled = false,
        listModel = null,
        listType = 'datepicker',
        clients = [],
        operatorsMap = {},
        types = [
            { value: '0', text: 'Ordinario' }, 
            { value: '1', text: 'Straordinario' }
        ],
        viewDefaults = {
            client: 'Scegli cliente',
            operators: 'Scegli operatori',
            zone: 'Scegli Area/Indirizzo'
        },
        validFields = {
            client: true,
            operators: true
        },
        view = {
            client: viewDefaults.client,
            operators: viewDefaults.operators,
            zone: viewDefaults.zone
        },
        areas = null,
        initialModel = '',
        model = {
            client: client ? client.id : '',
            zone: "",
            operators: "",
            type: "1",
            notes: ""
        },
        ruleModel = {
            cron: '',
            months: '',
            description: '',
            payload: '{}',
            effect: 'alert',
            client: client ? client.id : '',
            sector: $userStore.sector.id,
            filter1: '',
            filter2: ''
        },
        dateValue = moment().set('hours', 7).set('minutes', 0).toDate (),
        dateString = '';

    // moment.locale ('it');
    const dispatch = createEventDispatcher ();
    
    const save = (event) => {
        if (validateModel ()) {
            // ctrlsDisabled = true;
            ruleModel.payload = JSON.stringify (model)
            dispatch ('save', {
                data: ruleModel,
                previous: data
            })
        }
    }

    const cancel = (event) => {
        ctrlsDisabled = true;
        dispatch ('cancel', {
            data: data
        })
    }

    const validateModel = () => {
        validFields.client = model.client !== ''
        // validFields.operators = model.operators !== ''

        console.log ('validFields', validFields)

        return validFields.client;
    }

    const loadData = () => {
        const programdata = JSON.parse (data.payload);
        // console.log ('load data', data);

        if (data.cron)
            ruleModel.cron = data.cron;

        if (data.months)
            ruleModel.months = data.months;

        if (data.year)
            ruleModel.year = data.year;

        if (data.description)
            ruleModel.description = data.description;

        if (data.effect)
            ruleModel.effect = data.effect;

        if (data.client && data.client.id)
            ruleModel.client = data.client.id;

        if (data.filter1)
            ruleModel.filter1 = data.filter1;

        if (data.filter2)
            ruleModel.filter2 = data.filter2;

        

        if (data.client && data.client.id)
            model.client = data.client.id;
        if (programdata.zone)
            model.zone = programdata.zone;
            
        // if (programdata.description)
        //     model.description = programdata.description;
        if (programdata.operators)
            model.operators = programdata.operators;
        if (programdata.type !== undefined)
            model.type = programdata.type.toString();
        if (programdata.notes)
            model.notes = programdata.notes;

        if (data.client)
            view.client = data.client.name;
        if (data.oprts) {
            view.operators = data.oprts.map (it => {
                const { name, token_id } = it
                return {
                    name,
                    token_id
                }
            })
            toOpsMap ();
        }

        
        initialModel = JSON.stringify (model)
    }

    const toOpsMap = () => {
        console.log ('toOpsMap', view.operators)
        operatorsMap = Object.assign ({ }, ...view.operators.map (s => ({[s.token_id]: s})));
    }

    const toOpsList = () => {
        view.operators = Object.keys (operatorsMap).map (s => {
            return { ...operatorsMap[s] }
        });
        model.operators = view.operators.map (it => it.token_id).join(',')
    }

    const removeOperator = (event) => {
        if (operatorsMap[event.detail.id])
            delete operatorsMap[event.detail.id];

        toOpsList ();
        if (view.operators.length === 0)
            view.operators = viewDefaults.operators;

        view = view;
        model = model;
    }

    const onClientSelect = (event) => {
        const { detail } = event;
        console.log ('onClientSelect', detail)
        model.client = detail.id;
        ruleModel.client = detail.id;
        view.client = detail.name;

        if (detail.address.length > 1) {
            areas = detail.address;
        } else
            areas = null;
    }

    const onAreaSelect = (event) => {
        const { detail } = event;
        console.log ('onAreaSelect', detail)
        model.data = JSON.stringify ({ address: detail });
        view.zone = detail.name + ' (' + detail.city + ')';
    }

    const onOperatorSelect = (event) => {
        const { detail } = event;

        operatorsMap[detail.token_id] = detail;

        toOpsList ();
        // if (view.operators.length === 0)
        //     view.operators = viewDefaults.operators;

        view = view;
        model = model;
        // console.log ('onOperatorSelect', detail)
    }

    const onCronSelect = (event) => {
        const { detail } = event;

        ruleModel.cron = detail.cron;
        ruleModel.months = JSON.stringify (detail.months)
        ruleModel = ruleModel;
        listType = 'cron'
    }

    const onWorkSelect = (event) => {
        const { detail } = event

        // console.log ('onWorkSelect', detail)
        ruleModel.description = detail.description;
        ruleModel = ruleModel;
    }

    const onDateSelect = (event) => {
        const { date } = event.detail;
        // console.log ('onDateSelect', date)
        // dateValue = date;
        model.date = date.getTime ();
        dateString = moment(date).format ('dddd DD/MM/YYYY HH:mm')
    }

    const listClients = (event) => {
        listType = 'clients'
    }

    const listAreas = (event) => {
        listType = 'areas'
    }

    const listWorks = (event) => {
        listType = 'works'
    }

    // $: changed = initialModel !== JSON.stringify (model)

    // $: {
    //     console.log (JSON.stringify (ruleModel, null, '   '))
    // }
    
    $: {
        if (data)
            loadData (data)
    }
</script>

<ModalOverlay />
{#if data || create}
    <Modal classes="AlertEditor" hideOverlay>
        <div class="Editor basic-panel-content">
            <div class="content">
                <div class="heading">{create ? 'Crea Regola' : data.client.name}</div>
                <SveltePerfectScrollbar height={350}>
                    <div class="form">
                        <!-- <pre>{data ? JSON.stringify (ruleModel, null, '   ') : ''}</pre> -->
                        <CronEditor data={ruleModel.cron} on:select={onCronSelect} />
                        {#if client === null}
                            <ListField name="client" value={view.client} valid={validFields.client} 
                                on:list={listClients} />
                            {#if areas}
                                <ListField name="area" value={view.zone} 
                                    on:list={listAreas} />
                            {/if}
                        {/if}
                        <SmartField name="description" label="Descrizione" bind:value={ruleModel.description} 
                            type="textarea" on:clicked={listWorks} />
                        <ListField name="operators" value={view.operators} valid={validFields.operators} 
                            on:remove={removeOperator} 
                            on:list={e => { listType = 'operators' }} />
                        <SmartSelect name="type" bind:value={model.type} options={types} legacy />
                        <SmartField name="notes" label="Note" bind:value={model.notes} type="textarea" />
                    </div>
                </SveltePerfectScrollbar>
            </div>
            <div class="list">
                {#if listType === 'clients'}
                    <ListClients on:select={onClientSelect} on:app-event />
                {:else if listType === 'operators'}
                    <ListOperators sectorId={$userStore.sector.id} on:select={onOperatorSelect} on:app-event />
                {:else if listType === 'works'}
                    <ListWorks on:select={onWorkSelect} on:app-event />
                {:else if listType === 'areas'}
                    <ListAreas items={areas} on:select={onAreaSelect} on:app-event />
                {:else if listType === 'cron'}
                    <CronRenderer data={ruleModel.cron} />
                {/if}
            </div>
        </div>
        <div class="ctrls" in:fly={{ y: -60, duration: 300, delay: 300 }}>
            <button class="btn btn-sm btn-primary" disabled={ctrlsDisabled} on:click={save}>Salva Modifiche</button>
            <button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={cancel}>Annulla</button>
        </div>
    </Modal>
{/if}


<style>
    :global(.AlertEditor) .basic-panel-content {
        width: 960px;
        height: 400px;
        padding: 0;
        /* text-align: center; */
        position: relative;
        z-index: 2;
        
    }
    .Editor .content {
        position: relative;
        width: calc(100% - 260px);
        height: 100%;
        overflow: auto;
        /* padding: 20px; */
    }
    .Editor .heading {
        font-size: 20px;
        color: #465d6f;
        padding: 10px 20px;
        text-transform: capitalize;
    }
    .Editor .form {
        padding: 20px;
    }
    
    .Editor .list {
        position: absolute;
        width: 260px;
        height: 100%;
        top: 0;
        right: 0;
        border-left: 1px dashed #bacad1;
        background-color: #ecf2f6;
        overflow: hidden;
    }
    .ctrls {
        margin-top: 10px;
        text-align: left;
        position: relative;
        z-index: 1;
    }
    .ctrls :global(button) {
        padding: .40rem 1.3rem;
    }
    .ctrls :global(.btn) {
        margin-right: 5px;
    }

    @media(max-width: 800px) {
        :global(.AlertEditor) {
            width: 100%;
            height: 100%;
        }
        :global(.AlertEditor) .basic-panel-content {
            width: calc(100% - 50px);
            /* height: 100%; */
            left: 50px;
        }
    }
</style>